import isEnabled from '@wix/communities-blog-client-common/dist/src/services/is-experiment-enabled';

export const getExperiments = state => state.experiments;

export const isExperimentEnabled = (state, name, value) => isEnabled(getExperiments(state), name, value);
